<template>
  <div class="cookie-description table-contain">
    <table class="table small">
      <thead>
      <tr>
        <th>{{ 'Cookie' | translate }} / {{ 'Responsible Party' | translate }}</th>
        <th>{{ 'Category' | translate }}</th>
        <th>{{ 'Cookie Name' | translate }}</th>
        <th>{{ 'Purpose' | translate }}</th>
        <th>{{ 'Lifespan' | translate }}</th>
        <th>{{ 'Type of Cookie' | translate }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(cookie, key) in cookies" :key="key">
        <td>{{ cookie.name }} / {{ cookie.responsible_party }}</td>
        <td>{{ cookie.category | translate }}</td>
        <td>{{ cookie.cookies }}</td>
        <td>{{ cookie.purpose }}</td>
        <td>{{ cookie.lifespan }}</td>
        <td>{{ cookie.type | translate }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "CookieDescription",
  props: {
    cookies: {
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
.cookie-description {
  &.table-contain {
    display: flex;
    width: 100%;
    max-width: 100%;
    overflow-y: hidden;
    overflow-x: scroll;
  }
  
  .table {
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
    border-collapse: collapse;
    thead th {
      vertical-align: bottom;
      border-bottom: 2px solid #dee2e6;
    }
    td, th {
      padding: .75rem;
      vertical-align: top;
      border-top: 1px solid #dee2e6;
    }
  }

  .small, small {
    font-size: 80%;
    font-weight: 400;
  }
}
</style>
